import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Sparkles, ChevronRight } from 'lucide-react';
import { Button } from '../../ui/button';

/**
 * AssessmentPromptCard — chat card that nudges the user to take the
 * Movement Intelligence Baseline assessment. Rendered every day on
 * bootstrap until the user completes the 8-test flow. Tapping the
 * primary CTA routes them to /assessment.
 */
const AssessmentPromptCard = ({ data = {}, onAction }) => {
  const navigate = useNavigate();
  const headline = data.headline || 'Map your Movement IQ';
  const subhead = data.subhead || '8 short tests · ~5 minutes · we measure where you are, no guesswork';
  const cta = data.cta || 'Start Assessment';

  const start = () => {
    if (onAction) onAction({ action: 'navigate', payload: { route: '/assessment' } });
    navigate('/assessment');
  };

  return (
    <div className="hpme-card p-5 relative" data-testid="assessment-prompt-card">
      <div className="hpme-card-corner" />
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 rounded-sm bg-primary/20 flex items-center justify-center flex-shrink-0">
          <Sparkles className="w-5 h-5 text-primary" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="hpme-label mb-0.5">MOBILITY CHECK</p>
          <h3 className="font-secondary font-bold text-lg tracking-tight leading-tight">
            {headline}
          </h3>
          <p className="text-zinc-400 text-xs mt-1.5 leading-relaxed">{subhead}</p>
          <p className="text-zinc-500 text-[11px] mt-2 leading-relaxed">
            Left and right are scored separately, so any tightness or asymmetry shows up clearly. Nothing typed in — your camera does the reading.
          </p>
          <Button
            className="hpme-btn-primary mt-3 h-9"
            onClick={start}
            data-testid="assessment-prompt-start-btn"
          >
            {cta} <ChevronRight className="w-4 h-4 ml-1" />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AssessmentPromptCard;
